<template>
	<div class="rules">
		<FixedTool />
		<div class="banner"></div>
		<h2 class="title">

			{{index_data.complaint_text}}
		</h2>


		<div class="content">
			<div v-html="index_data.flash_ruletxt">
			</div>
			
        </div>
	</div>
</template>

<script>
export default {
	name: 'rules',
	metaInfo() {
		return {
			title: this.$ajax.is_activity() ? '活动规则' : '平台规则',
			titleTemplate: null,
			// meta: [
			// 	{ vmid: 'description', name: 'description', content: this.description }
			// ]
		}
	},
    data: () => ({
        index_data: {},
    }),
   mounted() {
       this.getIndexData()
    },
    methods: {
        getIndexData() {
            this.$ajax.get('m/trade/index_ts_fule_notice', {
                activity_id: this.$ajax.get_activity_id(),

            }).then(res => {
                this.index_data=res
            })
        },

	},
}
</script>

<style lang="less" scoped>
.rules {
	padding: 10px 14px;
	word-break: break-all;
	.banner {
			width: 100%;
			height: 68px;
			background-image: url(../assets/images/find_d_banner.png);
			background-color: #2B82ED;
			box-sizing: border-box;
			padding-left: 43px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			color: #fff;
		}
	.title {
		font-size: 15px;
		color: #333;
		font-weight: bold;
	}
	.datetime {
		font-size: 12px;
		color: #999999;
		margin: 10px 0;
	}

	.content {
		font-size: 13px;
		color: #666;
        line-height: 20px;
        img {
            width: 100%;
            margin: 10px 0;
        }
	}
}
</style>
